import React from "react";

/**
 * Card-shaped placeholders. They keep the grid at its final height while data
 * loads, instead of the old full-screen spinner that hid the whole page.
 */
const CardSkeletonGrid: React.FC<{ count?: number }> = ({ count = 10 }) => {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-xl border border-white/10 bg-space-800"
        >
          <div className="skeleton h-40 w-full animate-shimmer" />
          <div className="space-y-3 p-4">
            <div className="skeleton h-4 w-3/4 animate-shimmer rounded" />
            <div className="skeleton h-3 w-1/2 animate-shimmer rounded" />
            <div className="skeleton h-3 w-2/5 animate-shimmer rounded" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardSkeletonGrid;
